<template>
  <div id="app">
    <img class="bg" src="./assets/images/bg.png" alt="">
    <div class="head_bar">
      <!-- <el-alert type="error" effect="dark">
        <div slot="title">
          <i class="el-icon-warning"></i>
          <span>当前问卷可能含有敏感内容，请您仔细阅读后填写</span>
        </div>
      </el-alert> -->
      <el-progress :percentage="percentage" :show-text="false" />
    </div>

    <div class="content">
      <div class="list">
        <template v-if="['finish', 'error'].includes(pageState)">
          <div class="page_state">
            <i class="state_icon" :class="pageState === 'finish' ? 'el-icon-success' : 'el-icon-error'"></i>
            <template v-if="pageState === 'finish'">
              <p>问卷到此结束</p>
              <p>感谢您的参与</p>
            </template>
            <template v-else>
              <p>页面请求错误</p>
            </template>
          </div>
        </template>
        <template v-else-if="pageState === 'continue'">
          <div class="page_state">
            <p>是否继续上次填写？</p>
            <div class="btn_line">
              <el-button class="continue_btn" type="primary" :loading="loading" @click="onContinue">继续填写</el-button>
              <el-button class="again_btn" style="color: #409EFF;" :loading="loading" @click="onAgain">重新填写</el-button>
            </div>
          </div>
        </template>
        <template v-else-if="!pageState">
          <img v-if="!questionnaire || !questionnaire.length" class="title_img" src="./assets/images/title.png" alt="">
          <p class="page_title">{{ title }}</p>
          <div class="form_box">
            <template v-if="!questionnaire || !questionnaire.length">
              <div class="form_iten_box">
                <form-item :item-data="firstQuestion" v-model="wenjuan_type" />
              </div>
              <div class="btn_line">
                <el-button class="submit_btn" type="primary" :loading="loading"
                  @click="onChoosewenjuan_type">下一步</el-button>
              </div>
            </template>

            <template v-else>
              <!-- <FormItem v-for="(item, index) in questions" :key="index" :item-data="item" v-model="item.answer"
              @validateFormat="onGetValidateInfo($event, index)" @getUploadState="onChangeUploadState" /> -->
              <form-item v-for="(item, index) in questions" :key="index" :item-data="item" v-model="item.answer"
                @validateFormat="onGetValidateInfo($event, index)" @getUploadState="onChangeUploadState" />
              <div class="btn_line">
                <el-button class="submit_btn" type="primary" :loading="loading" @click="onSubmit">{{ submitBtnText
                  }}</el-button>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
    <suspended-ball @clickBall="onClickBall" />
  </div>
</template>
<script>
import FormItem from "./components/formItem.vue";
import SuspendedBall from "./components/suspended_ball.vue";
import { api } from "./axios/index";


export default {
  components: {
    'form-item': FormItem,
    'suspended-ball': SuspendedBall
  },

  data() {
    return {
      key: null, // 调查表的 key
      wj_member_id: null, // 问卷表的 id 
      title: '', // 调查表标题
      customer_url: '', // 投诉客服链接
      wenjuan_type: '', // 问卷类型
      questionnaire: null, // 当前调查表
      step: null, // 当前是第几步
      questions: [], // 当前步骤的问题
      percentage: 0, // 填写进度
      submitBtnText: '', // 提交按钮文本
      loading: false, // 请求中
      uploading: false, // 文件上传中
      firstQuestion: {
        index: 1,
        title: '请选择要投诉还是建议。',
        required: 1,
        type: 'radio',
        options: [
          { id: 'complaint', text: "投诉" },
          { id: 'suggestion', text: "建议" },
        ]
      },

      pageState: 'start', // 页面状态
      strType: ['radio', 'content', 'phone', 'memberid', 'membername', 'email', 'qq', 'weixin'], // 字符串答案类型
      arrType: ['checkbox', 'image', 'video'], // 数组答案类型
    };
  },
  computed: {

  },
  watch: {
    step(newVal) {
      if (newVal < 0) return
      if (newVal >= this.questionnaire.length) {
        this.$set(this, 'pageState', 'finish')
        this.$set(this, 'percentage', 100)
        localStorage.removeItem('wj_member_id')
        return
      }
      let questions = this.questionnaire[newVal]?.questions || []
      questions = questions.map(item => {
        const { type } = item
        if (this.strType.includes(type)) item.answer = ''
        else if (this.arrType.includes(type)) item.answer = []
        return item
      })
      const submitBtnText = newVal < this.questionnaire.length - 1 ? '下一步' : '提交'
      const percentage = Math.floor((newVal / this.questionnaire.length) * 10000) / 100

      this.$set(this, 'questions', questions)
      this.$set(this, 'submitBtnText', submitBtnText)
      this.$set(this, 'percentage', percentage)
    },

  },
  async created() {
    this.key = this.getKey()['key'] || ''
    const wj_member_id = localStorage.getItem('wj_member_id') || ''
    // if (!wj_member_id) return this.$set(this, 'pageState', '')
    this.$set(this, 'wj_member_id', wj_member_id)
    this.getSurveyData()
    // if (wj_member_id) {
    //   await this.getSurveyData((res) => {
    //     if (res.code) this.$set(this, 'pageState', 'continue')
    //     else this.onAgain()
    //   })
    // }
  },
  mounted() { },
  methods: {
    // 获取 key
    getKey() {
      const environment = process.env.NODE_ENV
      let URL
      if (environment === 'development') URL = "https://smrtvn.com/wenjuan?key=5"
      else URL = window.location.href
      if (URL.includes('http://127.0.0.1')) return { key: 5 }

      let url = URL.split("?")[1];
      const urlSearchParams = new URLSearchParams(url);
      const params = Object.fromEntries(urlSearchParams.entries());
      return params
    },
    // 处理当前调查表数据
    disposeQuestionnaire(questionnaire) {
      if (!questionnaire) return
      questionnaire = questionnaire.map(page => {
        page.questions = page.questions.map(item => {
          item.question.options.forEach(item_1 => {
            item_1.id = `${item_1.id}`
          })
          item = { ...item, ...item.question }
          item.index = item.index + 1
          delete item.question
          return item
        })
        return page
      })
      return questionnaire
    },
    // 选择问卷类型
    async onChoosewenjuan_type() {
      if (this.loading) return
      if (!this.wenjuan_type) return this.$message.error('请选择问卷类型');
      this.loading = true

      // 获取 问卷表 id
      let typeRes
      try {
        typeRes = await api({
          url: "/index/sur/choose_wenjuan_type",
          method: "post",
          data: {
            key: this.key,
            wenjuan_type: this.wenjuan_type
          }
        })
        if (this.wenjuan_type === 'complaint') this.title += ' - 投诉'
        else if (this.wenjuan_type === 'suggestion') this.title += ' - 建议'
      } catch (err) {
        this.loading = false
        return
      }
      this.loading = false
      const { code, data } = typeRes || {}
      if (!code) return
      this.wj_member_id = data.wj_member_id || ''
      localStorage.setItem('wj_member_id', this.wj_member_id)
      this.getSurveyData()

    },
    // 获取 调查表 问题列表
    async getSurveyData() {
      let surveyRes
      try {
        surveyRes = await api(`/index/sur/get_survey?key=${this.key}&id=${this.wj_member_id}`)
      } catch (err) {
        this.loading = false
        return
      }
      this.loading = false
      const { code, data } = surveyRes || {}
      if (!code) return this.$set(this, 'pageState', 'error')
      const { title, customer_url, pages } = data

      if (this.wenjuan_type === 'complaint') this.title = title + ' - 投诉'
      else if (this.wenjuan_type === 'suggestion') this.title = title + ' - 建议'
      else this.title = title
      this.$set(this, 'customer_url', customer_url)


      for (let type in pages) {
        if (this.wenjuan_type) break
        const list = pages[type]
        for (let item of list) {
          if (item.save_ok) this.wenjuan_type = type
          break
        }
      }
      if (!this.wenjuan_type) return this.$set(this, 'pageState', '')

      // 当前调查表的数据
      const questionnaire = this.disposeQuestionnaire(pages[this.wenjuan_type]) || []
      // 填写到第几步了
      let step = questionnaire.findIndex(item => !item.save_ok)
      if (step < 0) this.$set(this, 'pageState', 'finish')
      else if (step === 0) this.$set(this, 'pageState', '')
      else if (step > 0 && step < questionnaire.length - 1) this.$set(this, 'pageState', 'continue')

      this.$set(this, 'questionnaire', questionnaire)
      this.$set(this, 'step', step)
    },
    // 继续填写
    async onContinue() {
      // if (this.loading) return
      // this.loading = true
      // await this.getSurveyData()
      this.$set(this, 'pageState', '')
    },
    // 重新填写
    onAgain() {
      if (this.loading) return
      this.loading = true
      localStorage.removeItem('wj_member_id')
      localStorage.removeItem('wenjuan_type')
      location.reload(true)
    },
    // 点击悬浮球
    onClickBall() {
      window.open(this.customer_url)
    },
    // 获取 上传中 状态 
    onChangeUploadState(event) {
      this.uploading = event
    },
    // 获取表单校验信息
    // onGetValidateInfo(event, index) {
    //   let item = this.questions[index]
    //   item = { ...item, ...event }
    //   this.questions.splice(index, 1, item)
    // },
    // 校验必填项
    validateRequiredItem() {
      this.questions.forEach((item, index) => {
        const itemMap = JSON.parse(JSON.stringify(item))
        const { required, answer } = itemMap
        if (!required) return
        itemMap.pass = !!required && !!answer.length
        itemMap.errMsg = itemMap.pass ? "" : "这道题未回答"
        this.questions.splice(index, 1, itemMap)
      })
    },
    // 提交
    async onSubmit() {
      if (this.loading) return
      if (this.uploading) return this.$message.error('文件上传中,请等待文件上传完成后再提交');
      this.loading = true
      this.validateRequiredItem()
      const submitPass = !this.questions.find(item => (item.required && !item.pass))
      if (!submitPass) return this.loading = false

      const answerMap = {}
      this.questions.map(item => {
        const { answer, id, pass, type } = item
        if (!answer.length) return
        if (this.strType.includes(type)) answerMap[id] = answer
        else if (this.arrType.includes(type)) answerMap[id] = answer.join(',')
      })
      let res
      try {
        res = await api({
          url: "/index/sur/dosave",
          method: "post",
          data: {
            wj_member_id: this.wj_member_id,
            key: this.key,
            process_step: this.step,
            wenjuan_ok: this.step >= this.questionnaire.length - 1 ? 1 : 0,
            answer: answerMap,
          }
        })
      } catch (err) {
        this.loading = false
        return
      }
      this.loading = false
      if (!res.code) return this.$message.error(res?.msg);
      this.step++
    },
  }
}
</script>
<style lang="scss">
#app {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;

  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .head_bar {
    width: 100vw;
    position: absolute;
    top: 0;
    z-index: 99;
  }

  .content {
    // min-height: 500px;
    // max-height: 100%;
    height: 100%;
    background: #fff;
    box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .list {
      // flex: 1;
      height: 100vh;
      overflow-y: auto;
      position: relative;
      display: flex;
      flex-direction: column;

      .page_title {
        text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 30px;
      }

      .form_iten_box {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn_line {
        padding: 40px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .kefu {
          margin-top: 20px;
        }

        .continue_btn,
        .again_btn {
          width: 30%;
          max-width: 200px;
          margin: 0 40px;
        }

        .submit_btn {
          width: 50%;
          max-width: 300px;
        }
      }

      .page_state {
        text-align: center;
        font-size: 30px;
        margin-top: 100px;

        .state_icon {
          font-size: 70px;
          margin-bottom: 20px;

          &.el-icon-success {
            color: #7ec050;
          }

          &.el-icon-error {
            color: #e47470;
          }
        }
      }
    }
  }
}
</style>
